export default __webpack_public_path__ + "fcd2778.png";